/*
 * M2 Skins wishlist — client store + UI.
 *
 * localStorage is the working store for every shopper (guest and logged-in).
 * When a worker URL is configured (window.M2.wishlist.workerUrl) each add/remove
 * also fires a fire-and-forget reporting event to the Cloudflare worker; until
 * then the wishlist works fully offline. Logged-in metafield sync + merge-on-login
 * are layered on in a later phase and also gate on the worker URL.
 */
(function () {
  'use strict';

  var KEY = 'm2_wishlist';
  var CID_KEY = 'm2_wishlist_cid';
  var SID_KEY = 'm2_wishlist_sid';
  var SCHEMA_V = 1;
  var MAX_ITEMS = 200;
  var KIT_ORDER = ['essentials', 'pro', 'premium', 'ultimate'];
  var _kitCache = {};

  function safeParse(raw) {
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function load() {
    var data = safeParse(localStorage.getItem(KEY));
    if (!data || !Array.isArray(data.items)) return { v: SCHEMA_V, items: [] };
    return data;
  }

  function save(data) {
    try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
  }

  var state = load();

  function byNewest() {
    return state.items.slice().sort(function (a, b) { return (b.addedAt || 0) - (a.addedAt || 0); });
  }

  function indexOf(pid) {
    for (var i = 0; i < state.items.length; i++) {
      if (String(state.items[i].pid) === String(pid)) return i;
    }
    return -1;
  }

  function has(pid) { return indexOf(pid) >= 0; }
  function count() { return state.items.length; }

  function customer() {
    return (window.M2 && window.M2.customer && window.M2.customer.id) ? window.M2.customer : null;
  }
  function isLoggedIn() { return !!customer(); }

  function clientId() {
    var id = null;
    try { id = localStorage.getItem(CID_KEY); } catch (e) {}
    if (!id) {
      id = 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      try { localStorage.setItem(CID_KEY, id); } catch (e) {}
    }
    return id;
  }

  function sessionId() {
    var id = null;
    try { id = sessionStorage.getItem(SID_KEY); } catch (e) {}
    if (!id) {
      id = 's' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      try { sessionStorage.setItem(SID_KEY, id); } catch (e) {}
    }
    return id;
  }

  function scrollDepthPct() {
    var scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return 100;
    return Math.min(100, Math.round((window.scrollY / scrollable) * 100));
  }

  function collectionHandle() {
    var m = location.pathname.match(/^\/collections\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  /* ---- side effects: analytics + reporting ---- */

  function ga4(action, item) {
    var market = (window.M2 && window.M2.market) || 'GB';
    var entry = { item_id: 'shopify_' + market + '_' + item.pid + '_' + (item.vid || '0'), item_name: item.title };
    if (typeof item.price === 'number') entry.price = item.price / 100;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: action === 'add' ? 'add_to_wishlist' : 'remove_from_wishlist',
      ecommerce: { items: [entry] }
    });
  }

  function dedupKey(action, item) {
    return clientId() + '|' + action + '|' + (item.vid || item.pid) + '|' + Math.floor(Date.now() / 5000);
  }

  function report(action, item) {
    var cfg = (window.M2 && window.M2.wishlist) || {};
    if (!cfg.workerUrl) return;
    var cust = customer();
    var body = {
      event_type: action,
      product_id: item.pid,
      variant_id: item.vid || null,
      product_title: item.title || null,
      customer_id: cust ? cust.id : null,
      email: cust ? cust.email : null,
      client_id: clientId(),
      session_id: sessionId(),
      source: item.source || null,
      market: (window.M2 && window.M2.market) || null,
      page_url: location.href,
      referrer: document.referrer || null,
      collection_handle: collectionHandle(),
      viewport_width: window.innerWidth,
      scroll_depth_pct: scrollDepthPct(),
      cart_token: (window.Shopify && window.Shopify.cartToken) || null,
      dedup_key: dedupKey(action, item),
      ts: Date.now()
    };
    try {
      fetch(cfg.workerUrl.replace(/\/$/, '') + '/event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Auth-Key': cfg.authKey || '' },
        body: JSON.stringify(body),
        keepalive: true
      })['catch'](function () {});
    } catch (e) {}
  }

  /* ---- logged-in metafield sync + merge-on-login ---- */

  var SYNC_FLAG = 'm2_wishlist_synced_for';
  var _syncTimer = null;

  function workerBase() {
    var cfg = (window.M2 && window.M2.wishlist) || {};
    return cfg.workerUrl ? cfg.workerUrl.replace(/\/$/, '') : null;
  }

  function syncMetafield() {
    var base = workerBase();
    var cust = customer();
    var cfg = (window.M2 && window.M2.wishlist) || {};
    if (!base || !cust) return;
    clearTimeout(_syncTimer);
    _syncTimer = setTimeout(function () {
      try {
        fetch(base + '/wishlist/set', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Key': cfg.authKey || '' },
          body: JSON.stringify({ customer_id: cust.id, items: state.items })
        })['catch'](function () {});
      } catch (e) {}
    }, 600);
  }

  function mergeRemote(remote) {
    var changed = false;
    for (var i = 0; i < remote.length; i++) {
      var r = remote[i];
      if (!r || r.pid == null) continue;
      var idx = indexOf(r.pid);
      if (idx < 0) {
        state.items.push({
          pid: r.pid, vid: r.vid || null, handle: r.handle || '', url: r.url || '',
          title: r.title || '', image: r.image || '',
          price: typeof r.price === 'number' ? r.price : (parseInt(r.price, 10) || 0),
          addedAt: r.addedAt || Date.now()
        });
        changed = true;
      } else {
        var local = state.items[idx];
        if (r.addedAt && (!local.addedAt || r.addedAt < local.addedAt)) local.addedAt = r.addedAt;
        if (!local.title && r.title) local.title = r.title;
        if (!local.image && r.image) local.image = r.image;
        if (!local.url && r.url) local.url = r.url;
      }
    }
    if (changed) save(state);
    return changed;
  }

  // Runs on each authenticated page load. There is no Shopify "just logged
  // in" event, so we infer it: when SYNC_FLAG != current customer.id we do a
  // one-time read + union merge (guest list -> account), then push the union
  // back up. Union merges can't represent deletions, so an item removed on
  // one device can reappear from another — accepted (documented) for MVP.
  function reconcile() {
    var base = workerBase();
    var cust = customer();
    if (!cust) {
      try { localStorage.removeItem(SYNC_FLAG); } catch (e) {}
      return;
    }
    var syncedFor = null;
    try { syncedFor = localStorage.getItem(SYNC_FLAG); } catch (e) {}
    if (String(syncedFor) === String(cust.id)) return;
    if (!base) return;  // no worker yet — retry on a later load
    var cfg = (window.M2 && window.M2.wishlist) || {};
    fetch(base + '/wishlist?customer_id=' + encodeURIComponent(cust.id), {
      headers: { 'X-Auth-Key': cfg.authKey || '' }
    })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (data) {
        var remote = (data && Array.isArray(data.items)) ? data.items : [];
        mergeRemote(remote);
        try { localStorage.setItem(SYNC_FLAG, String(cust.id)); } catch (e) {}
        emit('sync', null);
        syncMetafield();
      })['catch'](function () {});
  }

  /* ---- mutations ---- */

  function add(item) {
    if (!item || item.pid == null || item.pid === '') return false;
    if (has(item.pid)) return false;
    if (state.items.length >= MAX_ITEMS) state.items.shift();
    var rec = {
      pid: item.pid,
      vid: item.vid || null,
      handle: item.handle || '',
      url: item.url || '',
      title: item.title || '',
      image: item.image || '',
      price: typeof item.price === 'number' ? item.price : (parseInt(item.price, 10) || 0),
      addedAt: Date.now()
    };
    state.items.push(rec);
    save(state);
    ga4('add', rec);
    report('add', rec);
    syncMetafield();
    emit('add', rec.pid);
    return true;
  }

  function remove(pid) {
    var i = indexOf(pid);
    if (i < 0) return false;
    var rec = state.items[i];
    state.items.splice(i, 1);
    save(state);
    ga4('remove', rec);
    report('remove', rec);
    syncMetafield();
    emit('remove', pid);
    return true;
  }

  function toggle(item) {
    if (item && has(item.pid)) { remove(item.pid); return false; }
    add(item);
    return true;
  }

  function emit(action, changedPid) {
    document.dispatchEvent(new CustomEvent('wishlist:change', {
      detail: { items: byNewest(), count: count(), changedPid: changedPid, action: action }
    }));
  }

  /* ---- rendering helpers ---- */

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents || 0) / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return String(Math.round(value));
        case 'amount_with_comma_separator': return value.toFixed(2).replace('.', ',');
        case 'amount_no_decimals_with_comma_separator': return String(Math.round(value));
        default: return value.toFixed(2);
      }
    });
  }

  function fetchKits(handle) {
    if (_kitCache[handle] !== undefined) return Promise.resolve(_kitCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product || !Array.isArray(product.variants)) { _kitCache[handle] = null; return null; }
        var opts = product.options || [];
        var optIdx = -1;
        // First pass: match by option name (storefront JSON returns objects; Admin API returns strings)
        for (var i = 0; i < opts.length; i++) {
          var optName = typeof opts[i] === 'string' ? opts[i] : (opts[i].name || '');
          if (/kit|configuration/i.test(optName)) { optIdx = i; break; }
        }
        // Second pass: find by value — if any variant has essentials/pro/premium/ultimate as an option value
        if (optIdx < 0 && product.variants.length > 1) {
          for (var oi = 0; oi < opts.length; oi++) {
            for (var vi = 0; vi < product.variants.length; vi++) {
              var val = (product.variants[vi]['option' + (oi + 1)] || '').toLowerCase();
              if (KIT_ORDER.indexOf(val) >= 0) { optIdx = oi; break; }
            }
            if (optIdx >= 0) break;
          }
        }
        if (optIdx < 0) { _kitCache[handle] = null; return null; }
        var tiers = {};
        for (var j = 0; j < product.variants.length; j++) {
          var v = product.variants[j];
          var name = v['option' + (optIdx + 1)];
          if (!name) continue;
          var key = name.toLowerCase();
          if (!tiers[key]) tiers[key] = { name: name, min: v.price };
          else if (v.price < tiers[key].min) tiers[key].min = v.price;
        }
        var result = [];
        KIT_ORDER.forEach(function (k) { if (tiers[k]) result.push({ name: tiers[k].name, min: tiers[k].min }); });
        Object.keys(tiers).forEach(function (k) {
          if (KIT_ORDER.indexOf(k) < 0) result.push({ name: tiers[k].name, min: tiers[k].min });
        });
        var out = result.length ? result : null;
        _kitCache[handle] = out;
        return out;
      })['catch'](function () { _kitCache[handle] = null; return null; });
  }

  var _imgCache = {};
  var _SKIP_TERMS = ['-interior', '-bottom', '-inside', '-palm', '-trackpad', '-keyboard'];

  function fetchBestImage(handle, title) {
    if (_imgCache[handle] !== undefined) return Promise.resolve(_imgCache[handle]);
    var titleHasPro = (title || '').toLowerCase().indexOf('pro') >= 0;
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product || !Array.isArray(product.media)) { _imgCache[handle] = null; return null; }
        var best = -1, pool = [];
        for (var i = 0; i < product.media.length; i++) {
          var m = product.media[i];
          if (m.media_type !== 'image') continue;
          var src = m.src || (m.preview_image && m.preview_image.src) || '';
          if (!src) continue;
          var fname = src.split('/').pop().split('?')[0].toLowerCase();
          var skip = false;
          for (var si = 0; si < _SKIP_TERMS.length; si++) {
            if (fname.indexOf(_SKIP_TERMS[si]) >= 0) { skip = true; break; }
          }
          if (skip) continue;
          var rank = 0;
          if (fname.indexOf('-ess-') >= 0) rank = 1;
          if (fname.indexOf('-prm-') >= 0) { rank = 2; }
          else if (fname.indexOf('-pro-') >= 0) {
            if (titleHasPro) {
              if (fname.replace('-pro-', '').indexOf('-pro-') >= 0) rank = 2;
            } else {
              rank = 2;
            }
          }
          if (fname.indexOf('-ult-') >= 0) rank = 3;
          if (best < 0 || rank > best) { best = rank; pool = [src]; }
          else if (rank === best) { pool.push(src); }
        }
        var picked = pool.length ? pool[Math.floor(Math.random() * pool.length)] : null;
        if (picked && picked.indexOf('_400x') < 0) {
          picked = picked.replace(/\.(jpe?g|png|gif|webp)(?=\?|$)/i, '_400x.$1');
        }
        _imgCache[handle] = picked;
        return picked;
      })['catch'](function () { _imgCache[handle] = null; return null; });
  }

  var _varOptCache = {};

  function fetchVariantOptions(handle, vid) {
    var cacheKey = handle + '|' + vid;
    if (_varOptCache[cacheKey] !== undefined) return Promise.resolve(_varOptCache[cacheKey]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product || !Array.isArray(product.variants)) { _varOptCache[cacheKey] = null; return null; }
        var variant = null;
        for (var i = 0; i < product.variants.length; i++) {
          if (String(product.variants[i].id) === String(vid)) { variant = product.variants[i]; break; }
        }
        if (!variant) { _varOptCache[cacheKey] = null; return null; }
        var opts = product.options || [];
        var result = [];
        for (var j = 0; j < opts.length; j++) {
          var optName = typeof opts[j] === 'string' ? opts[j] : (opts[j].name || '');
          var val = variant['option' + (j + 1)] || '';
          if (!val || val === 'Default Title') continue;
          result.push({ name: optName, value: val });
        }
        var out = result.length ? result : null;
        _varOptCache[cacheKey] = out;
        return out;
      })['catch'](function () { _varOptCache[cacheKey] = null; return null; });
  }

  function cardHtml(it, kits, variantOptions) {
    var priceSection;
    if (variantOptions && variantOptions.length) {
      priceSection = '<span class="wishlist-item__kits">';
      for (var i = 0; i < variantOptions.length; i++) {
        priceSection += '<span class="wishlist-item__kit-row">' +
          '<span class="wishlist-item__kit-name">' + escapeHtml(variantOptions[i].name) + '</span>' +
          '<span class="wishlist-item__kit-price">' + escapeHtml(variantOptions[i].value) + '</span>' +
          '</span>';
      }
      priceSection += '</span>';
    } else if (kits && kits.length) {
      priceSection = '<span class="wishlist-item__kits">';
      for (var i = 0; i < kits.length; i++) {
        priceSection += '<span class="wishlist-item__kit-row">' +
          '<span class="wishlist-item__kit-name">' + escapeHtml(kits[i].name) + '</span>' +
          '<span class="wishlist-item__kit-price">from ' + formatMoney(kits[i].min) + '</span>' +
          '</span>';
      }
      priceSection += '</span>';
    } else {
      priceSection = '<span class="wishlist-item__price">' + formatMoney(it.price) + '</span>';
    }
    return '<a class="wishlist-item" href="' + escapeHtml(variantUrl(it)) + '">' +
      (it.image
        ? '<img class="wishlist-item__img" src="' + escapeHtml(it.image) + '" alt="" loading="lazy">'
        : '<span class="wishlist-item__img wishlist-item__img--empty"></span>') +
      '<span class="wishlist-item__info">' +
        '<span class="wishlist-item__title">' + escapeHtml(it.title) + '</span>' +
        priceSection +
      '</span>' +
      '<button type="button" class="wishlist-item__remove" data-wishlist-remove data-pid="' + escapeHtml(it.pid) + '" aria-label="Remove from wishlist">&times;</button>' +
    '</a>';
  }

  var _heartSvg = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';

  function parseWishlistTitle(raw) {
    var t = (raw || '').trim();
    var yearMatch = t.match(/\s\((\d{4}(?:[-–—\/]\d{2,4})?)\)/);
    var year = yearMatch ? yearMatch[1] : '';
    if (yearMatch) t = t.replace(yearMatch[0], '').trim();
    var sp = t.indexOf(' ');
    return {
      mfr: sp > 0 ? t.slice(0, sp) : t,
      year: year,
      shortName: sp > 0 ? t.slice(sp + 1) : t
    };
  }

  function variantUrl(it) {
    var u = it.url || '#';
    if (it.vid && u !== '#') u += (u.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + encodeURIComponent(it.vid);
    return u;
  }

  function pageCardHtml(it, imgOverride, variantOptions) {
    var safeUrl = escapeHtml(variantUrl(it));
    var safeImg = escapeHtml(imgOverride || it.image || '');
    var safeTitle = escapeHtml(it.title || '');
    var safePid = escapeHtml(String(it.pid || ''));
    var parsed = parseWishlistTitle(it.title);
    var metaTop = (parsed.mfr || parsed.year)
      ? '<div class="m2cf-card__meta-top">' +
          '<span class="m2cf-card__mfr">' + escapeHtml(parsed.mfr) + '</span>' +
          '<span class="m2cf-card__year">' + escapeHtml(parsed.year) + '</span>' +
        '</div>'
      : '';
    var variantLine;
    if (variantOptions && variantOptions.length) {
      var vLine1 = [], vLine2 = [];
      for (var vi = 0; vi < variantOptions.length; vi++) {
        var vName = variantOptions[vi].name.toLowerCase();
        if (/material|vinyl|finish|colou?r/.test(vName)) {
          vLine2.push(variantOptions[vi].value);
        } else {
          vLine1.push(variantOptions[vi].value);
        }
      }
      var hasCutout = vLine1.length > 1;
      variantLine = '<div class="m2cf-card__variant">' +
        (hasCutout
          ? '<span class="m2cf-card__variant-row">' + escapeHtml(vLine1.join(' · ')) + '</span>' +
            (vLine2.length ? '<span class="m2cf-card__variant-row">' + escapeHtml(vLine2.join(' · ')) + '</span>' : '')
          : '<span class="m2cf-card__variant-row">' + escapeHtml(vLine1.concat(vLine2).join(' · ')) + '</span>') +
      '</div>';
    } else {
      variantLine = '<div class="m2cf-card__variant m2cf-card__variant--none"><span class="m2cf-card__variant-row">No Options Selected</span></div>';
    }
    return '<a class="m2cf-card" href="' + safeUrl + '">' +
      '<div class="m2cf-card__img">' +
        '<span class="m2cf-card__badge">' + formatMoney(it.price) + '</span>' +
        '<button type="button" class="m2cf-card__heart m2-wishlist-heart is-active" data-wishlist-toggle' +
          ' aria-pressed="true" data-source="wishlist_page"' +
          ' data-pid="' + safePid + '"' +
          ' data-handle="' + escapeHtml(it.handle || '') + '"' +
          ' data-url="' + safeUrl + '"' +
          ' data-title="' + safeTitle + '"' +
          ' data-image="' + safeImg + '"' +
          ' data-price="' + escapeHtml(String(it.price || 0)) + '"' +
          ' aria-label="Remove from wishlist">' +
          _heartSvg +
        '</button>' +
        (safeImg ? '<img class="m2cf-card__photo" src="' + safeImg + '" alt="" loading="lazy">' : '') +
      '</div>' +
      '<div class="m2cf-card__info">' +
        metaTop +
        '<span class="m2cf-card__title">' + escapeHtml(parsed.shortName) + '</span>' +
        variantLine +
      '</div>' +
    '</a>';
  }

  function renderHero() {
    var hero = document.querySelector('[data-wishlist-hero]');
    if (!hero) return;
    var list = byNewest();
    var n = list.length;
    hero.classList.toggle('is-empty', n === 0);

    var totalCents = 0, brands = {};
    for (var i = 0; i < list.length; i++) {
      totalCents += (typeof list[i].price === 'number' ? list[i].price : 0);
      var mfr = parseWishlistTitle(list[i].title).mfr;
      if (mfr) brands[mfr.toUpperCase()] = true;
    }
    var totalEl = hero.querySelector('[data-wishlist-total]');
    var brandsEl = hero.querySelector('[data-wishlist-brands]');
    if (totalEl) totalEl.textContent = n ? formatMoney(totalCents) : '—';
    if (brandsEl) brandsEl.textContent = Object.keys(brands).length;

    var fanEl = hero.querySelector('[data-wishlist-hero-fan]');
    if (!fanEl) return;
    if (n === 0) { fanEl.innerHTML = ''; return; }
    var top = list.slice(0, 3);
    var fanPromises = top.map(function (it) {
      var handle = it.handle;
      if (!handle && it.url) {
        var pm = it.url.match(/\/products\/([^?#/]+)/);
        if (pm) handle = pm[1];
      }
      return handle ? fetchBestImage(handle, it.title) : Promise.resolve(it.image || null);
    });
    Promise.all(fanPromises).then(function (imgs) {
      var html = '';
      for (var j = 0; j < top.length; j++) {
        var it = top[j];
        var img = imgs[j] || it.image || '';
        var parsed = parseWishlistTitle(it.title);
        html += '<div class="wl-hero__fan-card is-' + (j + 1) + '">' +
          (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '') +
          (j === 1 ? '<span class="wl-hero__fan-heart">' + _heartSvg + '</span>' : '') +
          '<div class="wl-hero__fan-cap">' +
            '<b>' + escapeHtml(parsed.shortName || it.title) + '</b>' +
            '<span>' + formatMoney(it.price) + '</span>' +
          '</div>' +
        '</div>';
      }
      fanEl.innerHTML = html;
    });
  }

  function renderList(container) {
    var list = byNewest();
    if (!list.length) {
      var emptyMsg = container.getAttribute('data-empty') || 'Your wishlist is empty.';
      var emptyHtml = '<p class="wishlist-empty">' + emptyMsg + '</p>';
      if (container.hasAttribute('data-wishlist-page-grid')) {
        emptyHtml += '<p class="wl-page__empty-cta"><a href="/collections/all-skins">Browse all skins &rarr;</a></p>';
      }
      container.innerHTML = emptyHtml;
      return;
    }
    var isPageGrid = container.hasAttribute('data-wishlist-page-grid');
    var html = '', i;
    for (i = 0; i < list.length; i++) {
      html += isPageGrid ? pageCardHtml(list[i]) : cardHtml(list[i]);
    }
    container.innerHTML = html;
    if (isPageGrid) {
      // Page grid: re-render with best ult/pro/ess image once fetched
      var pgSnap = list.slice();
      var pgPromises = pgSnap.map(function (it) {
        var handle = it.handle;
        if (!handle && it.url) {
          var pm = it.url.match(/\/products\/([^?#/]+)/);
          if (pm) handle = pm[1];
        }
        var imgP = handle ? fetchBestImage(handle, it.title) : Promise.resolve(null);
        var optP = (handle && it.vid) ? fetchVariantOptions(handle, it.vid) : Promise.resolve(null);
        return Promise.all([imgP, optP]);
      });
      Promise.all(pgPromises).then(function (pairs) {
        var newHtml = '';
        for (var j = 0; j < pgSnap.length; j++) newHtml += pageCardHtml(pgSnap[j], pairs[j][0], pairs[j][1]);
        container.innerHTML = newHtml;
      });
      return;
    }
    if (!container.hasAttribute('data-wishlist-list')) return;
    // Drawer: show selected variant options if vid stored, otherwise kit tier ranges
    var snap = list.slice();
    var promises = snap.map(function (it) {
      var handle = it.handle;
      if (!handle && it.url) {
        var m = it.url.match(/\/products\/([^?#/]+)/);
        if (m) handle = m[1];
      }
      if (!handle) return Promise.resolve({ kits: null, variantOptions: null });
      if (it.vid) {
        return fetchVariantOptions(handle, it.vid).then(function (opts) {
          return { kits: null, variantOptions: opts };
        });
      }
      return fetchKits(handle).then(function (kits) {
        return { kits: kits, variantOptions: null };
      });
    });
    Promise.all(promises).then(function (dataArr) {
      var newHtml = '';
      for (var j = 0; j < snap.length; j++) newHtml += cardHtml(snap[j], dataArr[j].kits, dataArr[j].variantOptions);
      container.innerHTML = newHtml;
    });
  }

  function renderSurfaces() {
    var grids = document.querySelectorAll('[data-wishlist-list], [data-wishlist-page-grid], [data-wishlist-account-grid]');
    for (var i = 0; i < grids.length; i++) renderList(grids[i]);
  }

  function stampHearts() {
    var btns = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var active = has(btn.getAttribute('data-pid'));
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = btn.querySelector('.m2-wishlist-heart__label');
      if (label) {
        label.textContent = active
          ? (btn.getAttribute('data-label-active') || 'In your wishlist')
          : (btn.getAttribute('data-label-idle') || 'Add to wishlist');
      }
    }
  }

  function updateBadge() {
    var els = document.querySelectorAll('[data-wishlist-count]');
    var n = count();
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      if (els[i].hasAttribute('data-wishlist-badge')) els[i].hidden = (n === 0);
    }
  }

  function wlToast(msg) {
    var el = document.createElement('div');
    el.textContent = msg;
    el.style.cssText = 'position:fixed;bottom:28px;left:50%;transform:translateX(-50%) translateY(8px);' +
      'background:var(--heading-color,#fff);color:var(--background,#000);padding:10px 20px;border-radius:100px;' +
      'font-size:.875rem;font-weight:500;z-index:9999;pointer-events:none;opacity:0;' +
      'transition:opacity .2s ease,transform .2s ease;white-space:nowrap;';
    document.body.appendChild(el);
    requestAnimationFrame(function () {
      el.style.opacity = '1';
      el.style.transform = 'translateX(-50%) translateY(0)';
    });
    setTimeout(function () {
      el.style.opacity = '0';
      el.style.transform = 'translateX(-50%) translateY(8px)';
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 220);
    }, 2400);
  }

  function refresh() {
    stampHearts();
    updateBadge();
    renderSurfaces();
    renderHero();
    maybeShowOptin();
  }

  /* ---- soft email opt-in (guests) ---- */

  var OPTIN_FLAG = 'm2_wishlist_email_optin';
  var OPTIN_CONSENT_TEXT = 'Email me about items on my wishlist.';

  function optedIn() {
    try { return !!localStorage.getItem(OPTIN_FLAG); } catch (e) { return false; }
  }

  function maybeShowOptin() {
    var forms = document.querySelectorAll('[data-wishlist-optin]');
    var show = !isLoggedIn() && count() > 0 && !optedIn();
    for (var i = 0; i < forms.length; i++) forms[i].hidden = !show;
  }

  function submitOptin(form) {
    var emailEl = form.querySelector('[data-wishlist-optin-email]');
    var consentEl = form.querySelector('[data-wishlist-optin-consent]');
    var note = form.querySelector('[data-wishlist-optin-note]');
    var email = emailEl ? emailEl.value.trim() : '';
    if (!consentEl || !consentEl.checked) return;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      if (note) { note.hidden = false; note.textContent = 'Please enter a valid email.'; }
      return;
    }
    var base = workerBase();
    var cfg = (window.M2 && window.M2.wishlist) || {};
    if (base) {
      var cust = customer();
      try {
        fetch(base + '/optin', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Auth-Key': cfg.authKey || '' },
          body: JSON.stringify({
            email: email,
            consent: true,
            consent_text: OPTIN_CONSENT_TEXT,
            source: 'wishlist_drawer',
            client_id: clientId(),
            customer_id: cust ? cust.id : null,
            dedup_key: clientId() + '|optin|' + email,
            ts: Date.now()
          })
        })['catch'](function () {});
      } catch (e) {}
    }
    try { localStorage.setItem(OPTIN_FLAG, email); } catch (e) {}
    // Collapse the form to a thank-you; next refresh hides it entirely.
    var rows = form.querySelectorAll('.wishlist-optin__text, .wishlist-optin__email, .wishlist-optin__consent, [data-wishlist-optin-submit]');
    for (var i = 0; i < rows.length; i++) rows[i].style.display = 'none';
    if (note) { note.hidden = false; note.textContent = "Saved — we'll keep you posted."; }
  }

  /* ---- drawer ---- */

  function drawerEl() { return document.getElementById('wishlist-drawer'); }

  function setDrawer(open) {
    var d = drawerEl();
    if (!d) return;
    if (open) renderSurfaces();
    d.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.classList.toggle('wishlist-drawer-open', open);
    var openBtn = document.querySelector('[data-wishlist-open]');
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* ---- item payload from a toggle button ---- */

  function itemFromButton(btn) {
    var vid = btn.getAttribute('data-vid');
    if (!vid) {
      var form = btn.closest('form.product-form');
      if (form) {
        var input = form.querySelector('[name="id"]');
        if (input) vid = input.value;
      }
    }
    return {
      pid: btn.getAttribute('data-pid'),
      vid: vid || null,
      handle: btn.getAttribute('data-handle') || '',
      url: btn.getAttribute('data-url') || '',
      title: btn.getAttribute('data-title') || '',
      image: btn.getAttribute('data-image') || '',
      price: parseInt(btn.getAttribute('data-price'), 10) || 0,
      source: btn.getAttribute('data-source') || 'pdp'
    };
  }

  /* ---- events ---- */

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation();
      toggle(itemFromButton(toggleBtn));
      return;
    }
    if (e.target.closest('[data-wishlist-open]')) { e.preventDefault(); setDrawer(true); return; }
    if (e.target.closest('[data-wishlist-share]')) {
      e.preventDefault();
      var items = byNewest();
      var lines = ['My M2 Skins wishlist:\n'];
      for (var si = 0; si < items.length; si++) {
        var it = items[si];
        var itemUrl = it.url ? ('https://m2skins.com' + it.url) : '';
        lines.push('• ' + (it.title || '') + ' — ' + formatMoney(it.price) + (itemUrl ? '\n  ' + itemUrl : ''));
      }
      var text = lines.join('\n');
      if (navigator.share) {
        navigator.share({ title: 'My M2 Skins wishlist', text: text })['catch'](function () {});
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () { wlToast('Wishlist copied — paste into any message'); })['catch'](function () { wlToast('Could not copy'); });
      } else {
        wlToast('Could not copy');
      }
      return;
    }
if (e.target.closest('[data-wishlist-close]')) { e.preventDefault(); setDrawer(false); return; }
    var removeBtn = e.target.closest('[data-wishlist-remove]');
    if (removeBtn) { e.preventDefault(); e.stopPropagation(); remove(removeBtn.getAttribute('data-pid')); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setDrawer(false);
  });

  document.addEventListener('change', function (e) {
    var consent = e.target.closest('[data-wishlist-optin-consent]');
    if (consent) {
      var form = consent.closest('[data-wishlist-optin]');
      var btn = form && form.querySelector('[data-wishlist-optin-submit]');
      if (btn) btn.disabled = !consent.checked;
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-wishlist-optin]');
    if (!form) return;
    e.preventDefault();
    submitOptin(form);
  });

  document.addEventListener('wishlist:change', refresh);

  window.M2Wishlist = {
    add: add,
    remove: remove,
    toggle: toggle,
    has: has,
    getList: byNewest,
    count: count,
    isLoggedIn: isLoggedIn,
    stamp: stampHearts
  };

  refresh();
  reconcile();
})();
